import { render, staticRenderFns } from "./DialogSalesOrder.vue?vue&type=template&id=37f3fb81"
import script from "./DialogSalesOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSalesOrder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports